<template>
  <card>
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <h2>
            {{parameters.name}}
            <span>參數設定</span>
          </h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-sm-4">
              <label class="col-sm-6 col-form-label">啟用LINE點餐</label>
              <n-switch v-model="parameters.isEnabled" @click.native="shopStatus(parameters.accountId)" color="green">
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-exclamation" style="color:red;" slot="off"></i>
              </n-switch>
            </div>
            <div class="col-sm-4">
              <label class="col-sm-6 col-form-label">菜單樣式 <span v-if="parameters.isNewStyle == true">(單欄)</span><span v-if="parameters.isNewStyle !== true">(雙欄)</span></label>
              <n-switch v-model="parameters.isNewStyle">
                  <i class="fa fa-list" style="color:#BA0000;" slot="on"></i>
                  <i class="fa fa-columns" style="color:#0000BA;" slot="off"></i>
              </n-switch>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="row">
            <label class="col-sm-6 col-form-label">顯示統一編號欄位</label>
            <n-switch v-model="parameters.isInvoice" color="green">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="row">
            <label class="col-sm-6 col-form-label">提供收據</label>
            <n-switch v-model="parameters.isReceipt" color="green">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="row">
            <label class="col-sm-6 col-form-label">啟用自取</label>
            <n-switch v-model="parameters.isEatIn"  color="green">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="row">
            <label class="col-sm-6 col-form-label">啟用院內直送</label>
            <n-switch v-model="parameters.isToGo"  color="green">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="row">
            <label class="col-sm-6 col-form-label">啟用宅配</label>
            <n-switch v-model="parameters.isDelivery"  color="green">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </div>
        </div>
      </div>
      
      <div class="row justify-content-center">
        <div class="col-md-12">
          <div class="row">
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">商店Email*</label>
                <div class="col-sm-8">
                  <fg-input name="email" placeholder="Email" v-model="parameters.businessEmail"></fg-input>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">商店電話*</label>
                <div class="col-sm-8">
                  <fg-input name="phone" type="tel" placeholder="Phone" v-model="parameters.businessPhone"></fg-input>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-2 col-form-label">商店地址*</label>
            <div class="col-sm-6">
              <fg-input name="address" placeholder="Address" v-model="parameters.businessAddress"></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">商品數量重置時間</label>
                <div class="col-sm-8">
                  <fg-input placeholder="商品數量重置時間Ex 00:10:00" v-model="parameters.resetTime"></fg-input>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">宅配費用</label>
                <div class="col-sm-8">
                  <fg-input placeholder="請輸入宅配費用" type='number' min='0' v-model="parameters.shippingFee"></fg-input>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">預估宅配天數</label>
                <div class="col-sm-8">
                  <fg-input placeholder="請輸入宅配天數" type='number' min='0' v-model="parameters.estimatedShippingDays"></fg-input>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">按鈕名稱1</label>
                <div class="col-sm-8">
                  <fg-input placeholder="請輸入按鈕名稱" v-model="parameters.displayBtn1"></fg-input>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-2 col-form-label">營業資訊</label>
            <div class="col-sm-10">
              <el-input
                  type="textarea"
                  placeholder=""
                  v-model="parameters.storeInfo"
                  maxlength="200"
                  show-word-limit
                >
                </el-input>
            </div>
          </div>
          <br>

          <div class="row">
            <label class="col-sm-2 col-form-label">公告</label>
            <div class="col-sm-10">
              <quill-editor
                v-model="content"
                ref="myTextEditor"
                :options="editorOption"
                @blur="onEditorBlur($event)"
                @focus="onEditorFocus($event)"
                @ready="onEditorReady($event)"
              ></quill-editor>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-sm-6">
          <n-button type="default" @click.native="back">返回</n-button>
        </div>
        <div class="col-sm-6">
          <n-button type="warning" @click.native="save" :disabled="saveDisabled">儲存</n-button>
        </div>
      </div>
    </div>

  </card>
</template>

<script>

import { Card, StatsCard } from "src/components";
import {
  Checkbox,
  Radio,
  Switch,
  FormGroupInput as FgInput
} from "src/components/index";
import { fetchShopInfo } from "./fetchData";
import { shopEdit, shopStatus } from "./updateData";
import swal from 'sweetalert2';

import axios from 'axios';

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    Card,
    StatsCard,
    Checkbox,
    Radio,
    FgInput,
    [Switch.name]: Switch,
    quillEditor
  },
  beforeRouteEnter(to, from, next) {
    let id = to.params.id;
    fetchShopInfo(id)
      .then(res => {
        console.log("res: ", res.data)
        next(vm => vm.setData(res.data));
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  data() {
    return {
      saveDisabled: false,
      content: "",
      editorOption: {
        // some quill options
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],    //加粗，斜體，下劃線，刪除線
            // ['blockquote', 'code-block'],     //引用，程式碼塊
            // [{ 'header': 1 }, { 'header': 2 }],        // 標題，鍵值對的形式；1、2表示字型大小
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],     //列表
            // [{ 'script': 'sub'}, { 'script': 'super' }],   // 上下標
            // [{ 'indent': '-1'}, { 'indent': '+1' }],     // 縮排
            // [{ 'direction': 'rtl' }],             // 文字方向
            [{ 'size': ['small', false, 'large', 'huge'] }], // 字型大小
            [{ 'color': [] }, { 'background': [] }],     // 字型顏色，字型背景顏色
            // [{ 'font': [] }],     //字型
            // [{ 'align': [] }],    //對齊方式
            ['clean'],    //清除字型樣式
          ]
        },
        placeholder: '請輸入公告...',
        theme: 'snow'
      },
      parameters: {
        
      },
      dialogFormVisible: false,
      timeArr : [{
        start: "",
        end: ""
      }],
      numOfReservedDay: 0,
      timeLengthArr: [{
        label: "5分鐘",
        value: 5
      },{
        label: "10分鐘",
        value: 10
      },{
        label: "15分鐘",
        value: 15
      },{
        label: "20分鐘",
        value: 20
      },{
        label: "30分鐘",
        value: 30
      },{
        label: "60分鐘",
        value: 60
      }],
      numOfReservedDayArr: [{
        label: "1天",
        value: 1
      },{
        label: "2天",
        value: 2
      },{
        label: "3天",
        value: 3
      },{
        label: "4天",
        value: 4
      },{
        label: "5天",
        value: 5
      },{
        label: "6天",
        value: 6
      },{
        label: "7天",
        value: 7
      }],
      settingTimeArr: [],
      timeSectorLength: 15,
      timePickerOptions: {
        format: 'HH:mm'

      },
      timePickerValue: ['00:00', '23:59'],
      timePickerObjArr: [],
      timeSectorsLengthDisplay: ""
    };
  },
  methods: {
    setData(data) {
      data.isEatIn = data.isEatIn ? true : false;
      data.isDelivery = data.isDelivery ? true : false;
      data.isToGo = data.isToGo ? true : false;
      data.isEnabled = data.isEnabled ? true : false;
      data.isManual = data.isManual ? true: false;
      data.isNewStyle = data.isNewStyle ? true: false;

      if(data.content) {
        try {
          this.$refs.myTextEditor.quill.setContents(JSON.parse(data.content).ops);
        } catch(err) {
          let d = {
            ops: [{"insert": data.content}]
          };
          this.$refs.myTextEditor.quill.setContents(d);
          console.log(err);
        }
      }

      this.parameters = Object.assign({}, { ...data });
      this.convertToTimeObjArr(data.timeSetting);
    },
    save() {
      this.parameters.content = JSON.stringify(this.$refs.myTextEditor.quill.getContents());
      this.parameters.version = 'newOrderTimeSetting';
      if(this.parameters.timeSectorLength <= 0) {
        this.$message({
          type: 'error', message: '時間選項間隔(分鐘)請輸入大於0的數字'
        });
      } else if(this.parameters.timeSectorDays < 0) {
        this.$message({
          type: 'error', message: '可預訂天數（天）請輸入大於等於0的數字'
        });
      } else {
      this.saveDisabled = true;
        shopEdit(this.parameters)
        .then(res => {
          this.$message({
              type: 'success', message: '修改成功'
            });
          this.saveDisabled = false;
        })
        .catch(err => {
          this.$message({
            type: 'error', message: '修改失敗'
          });
          console.log("err: ", err.stack);
          this.saveDisabled = false;
        });
      }
      
    },
    shopStatus() {
      shopStatus(this.parameters)
      .then(res => {
        swal("線上接單狀態已更改")
      })
      .catch(err => {
        console.log("err: ", err)
      });
    },
    back() {
      window.history.back();
    },
    appendTimeArr() {
      this.timeArr.push({
        start: "",
        end: ""
      });
    },
    appendTimePickerArr() {
      this.timePickerObjArr.push({
        start: this.timePickerValue[0],
        end: this.timePickerValue[1]
      });
      this.timePickerValue = ['00:00', '23:59']
    },
    settingConfirm() {
      var isChecked = true;
      if(this.timePickerObjArr.length > 0) {
        this.dialogFormVisible = false;
        
      } else {
        this.$message({
          type: 'error', message: '請至少設定一個時段'
        });
      }
    },
    remove(index) {
      this.timeArr.splice(index, 1);
    },
    removeTimePicker(scope) {
      this.timePickerObjArr.splice(scope.$index, 1);
    },
    calSettingTime() {
      let timeSectorLength = this.parameters.timeSectorLength;
      let sectorLenPerHr = 60 / timeSectorLength;
      let maxSector = 1 * 24 * sectorLenPerHr;
      let settingTimeArr = [];
      for (let sector = 0; sector <= maxSector; sector++) {
        let value = sector / sectorLenPerHr;
        if(value.toString().length <= 5) {
          let hr = Math.floor(value).toString().padStart(2, "0");
          let min = ((value % 1) * 60).toString().padStart(2, "0");
          settingTimeArr.push({
            label: `${hr}:${min}`,
            value: value
          });
        }
      }
      this.settingTimeArr = settingTimeArr;
    },
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      console.log("editor ready!", quill);
    },
    convertToTime(numArr) {
      return numArr.map(t => {
        let s_h = Math.floor(t.start)
                .toString()
                .padStart(2, "0");
        let s_m = (t.start % 1 * 60)
                .toString()
                .padStart(2, "0");
        let e_h = Math.floor(t.end)
                .toString()
                .padStart(2, "0");
        let e_m = (t.end % 1 * 60)
                .toString()
                .padStart(2, "0");
        let start = `${s_h}:${s_m}`;
        let end = `${e_h}:${e_m}`;
        return {
          start,
          end
        }
      })
      
    },
    convertToTimeObjArr(timeSettings) {
      let timeObjSectors = this.parameters.timeObjSectors;
      let timeSectorDays = this.parameters.timeSectorDays;

      if(timeObjSectors) {
        this.timePickerObjArr = JSON.parse(timeObjSectors);
        this.numOfReservedDay = timeSectorDays;
      } else if(timeSettings) {
        let timeSettingArr = timeSettings.split(",");
        let days = timeSettingArr.pop();
        this.numOfReservedDay = Number(days);
        this.timeArr = timeSettingArr.map((timeStr, index) => {
          let start = Number(timeStr.split('-')[0]);
          let end = Number(timeStr.split('-')[1]);
          return {
            start,
            end
          };
        });
        this.timePickerObjArr = this.convertToTime(this.timeArr);
        console.log("this.timePickerObjArr: ", this.timePickerObjArr)
      }
    }
    
  },
  watch: {
    timePickerObjArr: function() {
      this.timeSectorsLengthDisplay = `${this.timePickerObjArr.length}`;
      this.parameters.timeObjSectors = this.timePickerObjArr;
    },
    numOfReservedDay: function(val) {
      this.parameters.timeSectorDays = val;
    }
  }
};
</script>